import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { InputForm, TextAreaInputForm } from 'controls/Input'
import PhoneInput from 'controls/PhoneInput'
import { validateContactFormPage } from 'app/validators/contact'
import Button from 'controls/Button'
import { Row, Col } from 'flexbox'
import { isContentCountry } from 'globalConfigApp'
import RgpdCoponent from 'components/Rgpd'
import { companyConfig } from 'globalConfigApp'

import styles from './style'
import { common } from '../styles'

export class ContactForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasExperience: true,
      checkedRgpd: !isContentCountry(['es'])
    }
  }

  static defaultProps = {
    style: {}
  }

  render() {
    const { handleSubmit, invalid, style, centered } = this.props
    const { checkedRgpd } = this.state
    return (
      <form className="form-container" onSubmit={handleSubmit} style={style}>
        <h3>Formulario de contacto</h3>
        <Row>
          <Col xs={12}>
            <Field
              className="form-input-margin"
              name="name"
              id="name"
              component={InputForm}
              placeholder="Nombre"
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <Field
              className="form-input-margin"
              name="phone"
              id="phone"
              component={PhoneInput}
              placeholder="Teléfono"
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <Field
              className="form-input-margin"
              name="email"
              id="email"
              component={InputForm}
              placeholder="Correo Electrónico"
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <Field
              className="form-input-margin"
              name="message"
              id="message"
              component={TextAreaInputForm}
              placeholder="Mensaje"
            />
          </Col>
        </Row>
        <RgpdCoponent handleValidRgpd={(checkedRgpd) => this.setState({ checkedRgpd })} checkedRgpd={checkedRgpd} />
        <Row>
          <Col xs={12} className="actions">
            <Button
              color="primary"
              fullWidth
              type="submit"
              className="submit"
              disabled={invalid && !checkedRgpd}
            >
              Contactar
            </Button>
            <p className="terms">
              Al hacer clic en "Contactar" estoy de acuerdo con los{' '}
              <span className="terms-link">Términos y Condiciones</span> para
              recibir información de parte de {companyConfig.name}.
            </p>
          </Col>
        </Row>

        <style jsx>{styles}</style>
        <style jsx>{common}</style>
      </form>
    )
  }
}

const formConfig = {
  form: 'contactFormPage',
  validate: validateContactFormPage
}

export default reduxForm(formConfig)(ContactForm)
